











import { defineComponent, getCurrentInstance } from "@vue/composition-api";
import { sendGaEvent } from "@/helpers/ga-helper";
export interface Props {
  name: string;
  ariaLabel: string;
  height: number;
  width: number;
  iconClass: string | Array<string>;
}
export default defineComponent({
  name: "OccIcon",
  props: {
    name: {
      type: String,
      default: ""
    },
    ariaLabel: {
      type: String,
      default: ""
    },
    height: {
      type: String,
      default: ""
    },
    width: {
      type: String,
      default: ""
    },
    iconClass: {
      type: Array,
      default: () => []
    },
    gaEventCategory: {
      type: String,
      default: ""
    }
  },
  setup(_, { emit }) {
    const instance = getCurrentInstance();
    const handleClick = () => {
      if (instance) sendGaEvent(instance.proxy);
      emit("click");
    };
    return {
      handleClick
    };
  }
});
